import NewBaseTable, { ColumnConfig } from 'components/NewBaseTable/NewBaseTable';
import { ItemOrder, Product } from 'types/parts';
import {
  OrderIcon,
  OrderIconContainer,
  OrderIconWrapper,
  PurchaseOrder
} from './NewSFOrdersTableStyled';
import ReorderIcon from '../../icons/img/reorder.svg';
import { useDispatch } from 'react-redux';
import { cartActions } from 'actions';
import { UNIVERSAL_PRODUCTS_KEY } from 'constants/cart';
import { useAddProductToRemoteCartMutation } from 'api';
import { ComposeCartItem } from 'components/MachinePartsTable/CartHelp';
import { CartItem } from 'types/parts/cart';
import { TooltipWrapper } from 'components';
import theme from 'common/theme';
interface NestedProps {
  products: ItemOrder[];
}
interface NestedConfigProps {
  addTwowayItemToCart: (items: Product) => void;
}
const generateColumnConfigs = ({ addTwowayItemToCart }: NestedConfigProps): ColumnConfig[] => {
  return [
    {
      id: 'action',
      header: '',
      isEnableSorting: false,
      isSelected: true,
      renderer: ({ row, getValue }) => {
        return (
          <div className={'parent-cell'} style={{ color: 'white' }}>
            {'....'}
          </div>
        );
      }
    },
    {
      id: 'name',
      header: 'Product Name',
      isEnableSorting: false,
      isSelected: true,

      renderer: (cellValue) => cellValue.getValue()
    },
    {
      id: 'sku',
      header: 'Part No.',
      isEnableSorting: false,
      isSelected: true,

      renderer: (cellValue) => cellValue.getValue()
    },
    {
      id: 'quantity',
      header: 'Qty',
      isEnableSorting: false,
      isSelected: true,

      renderer: (cellValue) => cellValue.getValue()
    },
    {
      id: 'stock',
      header: 'Stock',
      isEnableSorting: false,
      isSelected: true,
      renderer: (cellValue) => cellValue.getValue()
    },
    {
      id: 'subtotal',
      header: 'Price',
      isEnableSorting: false,
      isSelected: true,
      renderer: (cellValue) => cellValue.getValue()
    },
    {
      id: 'leadTime',
      header: 'Lead Time',
      isEnableSorting: false,
      isSelected: true,
      renderer: (cellValue) => cellValue.getValue()
    },
    {
      id: 'urgent',
      header: 'Urgent',
      isEnableSorting: false,
      isSelected: true,
      renderer: (cellValue) => (cellValue.getValue() === "False" ? 'No' : 'Yes')
    },
    {
      id: 'tentativeDeliveryDate',
      header: 'Tentative Delivery Date',
      isEnableSorting: false,
      isSelected: true,
      renderer: (cellValue) => cellValue.getValue()
    },
    {
      id: 'isDummy1',
      header: '',
      isEnableSorting: false,
      isSelected: true,
      renderer: (cellValue) => {
        const row = cellValue.row.original as Product;
        const orderQuote = cellValue.row.original as ItemOrder;
     
        return (
          orderQuote.orderStatus && orderQuote.orderStatus.toLowerCase() !== 'in progress' && 
            (<OrderIconContainer>
            <PurchaseOrder
              onClick={() => {
                addTwowayItemToCart(row);
              }}
            >
              <TooltipWrapper
                Tooltip={
                  'Reorder'
                }
                textColor={theme.colors.black}
                backGroundColor={theme.colors.white}
              >
                <OrderIconWrapper marginLeft={'0'} isClickable={true}>
                  <OrderIcon src={ReorderIcon} /> 
                </OrderIconWrapper>
              </TooltipWrapper>
            </PurchaseOrder>
          </OrderIconContainer>)
        );
      }
    }
  ];
};
const NestedProductOrderHistory = ({ products }: NestedProps): JSX.Element => {
  const dispatch = useDispatch();
  const [AddProductToRemoteCart] = useAddProductToRemoteCartMutation();
  const addTwowayItemToCart = async (item: Product) => {
    if (item) {
      const product: Product = {
        id: item.id as string,
        description: item.description as string,
        sku: item.sku as string,
        price: Number(item.price),
        priceUnit:item.priceUnit as string,
        isPurchasable: true,
        leadTime: item.leadTime || 0,
        stock: item.stock || 1,
        businessUnit: 'proseal'
      };

      AddProductToRemoteCart([ComposeCartItem(product, item.machineId as string, item.machineName as string)] as CartItem[])
          .unwrap()
          .then(() => {
                                      // maintain temporay FE cartState to track cart count
               dispatch({
                  type: cartActions.ADD_TO_CART,
                  item: product,
                  quantity: item.quantity,
                  groupId:
                    item.machineInfo !== undefined
                      ? item.machineId
                        ? item.machineId
                        : UNIVERSAL_PRODUCTS_KEY
                      : UNIVERSAL_PRODUCTS_KEY,
                  groupDescription:
                    item.machineInfo !== undefined
                      ? item.machineName
                        ? item.machineName
                        : UNIVERSAL_PRODUCTS_KEY
                      : UNIVERSAL_PRODUCTS_KEY
                });
            })
           .catch((error) => {
              console.warn('Error adding item to cart: ', error);
            });
      
    }
  };

  return (
    <div className="sip-nested-table">
      <NewBaseTable
        newTableData={products as ItemOrder[]}
        columnConfigs={generateColumnConfigs({ addTwowayItemToCart })}
        customClassName="changeover-program-steps"
        textAlign="left"
        tdMarginLeft="0.625rem"
        sortState={{ id: 'name', desc: false }} // sort by name in descending order by default
        isShowColumnOptions={false}
        isShowGlobalSearch={false}
        disableVirtualize={true}
        hideTotalFetchCount={true}
      />
    </div>
  );
};

export default NestedProductOrderHistory;
